export const mapbox =
    "pk.eyJ1IjoibWlsdXRpbm92aWNpIiwiYSI6ImNrczdjY3lyMjNmdHMyd3M3YWRhZzczbDcifQ.K3hhN2RCoSvKLooKJx80Xg";
